export const GlobalProperties = {
    headers: {
        authorization: {
            name: 'Authorization',
            prefix: 'Bearer '
        }, 
        basicAuthorization: {
            name: 'BasicAuthorization',
            prefix: 'Basic '
        }
    }
}